import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
import Link from "next/link";
import { usePlausible } from "next-plausible";
import AnimateHeight from "react-animate-height";
import { FormWrapper, CauseAreaTitle, CauseAreaContext, TotalSumWrapper, SumWrapper, SumButtonsWrapper, InputList, OrganizationInputWrapper, OperationsPercentageInputWrapper } from "../AmountPane.style";
import { getCauseAreaIconById } from "../SelectionPane.style";
import { CauseArea } from "../../../types/CauseArea";
import { ShareType } from "../../../types/Enums";
import { setCauseAreaAmount, setOrgAmount, setCauseAreaDistributionType, setOperationsPercentageModeByCauseArea, setOperationsPercentageByCauseArea, setShowAllOrganizations, setHasManuallyEditedPrefilledOrgAmount } from "../../../store/donation/actions";
import { thousandize } from "../../../../../../../util/formatting";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { RadioButtonGroup } from "../../../../RadioButton/RadioButtonGroup";
import { CheckBoxWrapper, HiddenCheckBox } from "../Forms.style";
import { CustomCheckBox } from "../DonorPane/CustomCheckBox";
import { OperationsConfig, CauseAreaDisplayConfig, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaRollout } from "../../shared/CauseAreaRollout/CauseAreaRollout";
import { splitOperationsLabelTemplate } from "../../../utils/operationsLabel";
import { useIsMobile } from "../../../../../../../hooks/useIsMobile";
interface CauseAreaFormProps {
  causeArea: CauseArea;
  isSingleSelection: boolean;
  suggestedSums: Array<{
    amount: number;
    subtext?: string;
  }>;
  causeAreaAmounts: Record<number, number>;
  orgAmounts: Record<number, number>;
  causeAreaDistributionType: Record<number, ShareType>;
  showOperationsOption?: boolean;
  operationsConfig?: OperationsConfig;
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  smartDistributionContext: SmartDistributionContext;
}
export const CauseAreaForm: React.FC<CauseAreaFormProps> = t0 => {
  const $ = _c(62);
  const {
    causeArea,
    isSingleSelection,
    suggestedSums,
    causeAreaAmounts,
    orgAmounts,
    causeAreaDistributionType,
    showOperationsOption: t1,
    operationsConfig,
    causeAreaDisplayConfig,
    smartDistributionContext
  } = t0;
  const showOperationsOption = t1 === undefined ? false : t1;
  const dispatch = useDispatch();
  const plausible = usePlausible();
  const isMobile = useIsMobile();
  const hasSingleOrg = causeArea.organizations.length <= 1;
  const isOtherCauseArea = causeArea.id === 5;
  const hideDistributionToggle = hasSingleOrg || isOtherCauseArea;
  const currentCauseAreaAmount = causeAreaAmounts[causeArea.id] || 0;
  const {
    operationsPercentageModeByCauseArea: t2,
    operationsPercentageByCauseArea: t3,
    operationsConfig: stateConfig,
    prefilledShares: t4,
    showAllOrganizations: t5,
    hasManuallyEditedPrefilledOrgAmount: t6
  } = useSelector(_temp);
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const operationsPercentageModeByCauseArea = t7;
  let t8;
  if ($[2] !== t3) {
    t8 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const operationsPercentageByCauseArea = t8;
  const prefilledShares = t4 === undefined ? null : t4;
  const showAllOrganizations = t5 === undefined ? false : t5;
  const hasManuallyEditedPrefilledOrgAmount = t6 === undefined ? false : t6;
  const activeOrganizations = causeArea.organizations.filter(_temp2).sort(_temp3);
  let t9;
  if ($[4] !== prefilledShares) {
    t9 = organization_0 => prefilledShares?.[organization_0.id] !== undefined;
    $[4] = prefilledShares;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const hasPrefilledOrganizations = activeOrganizations.some(t9);
  const isTrackingPrefilledShares = hasPrefilledOrganizations && !hasManuallyEditedPrefilledOrgAmount;
  const visibleOrganizations = hasPrefilledOrganizations && !showAllOrganizations ? activeOrganizations.filter(organization_1 => prefilledShares?.[organization_1.id] !== undefined) : activeOrganizations;
  const config = operationsConfig || stateConfig;
  const defaultPercentage = config?.defaultPercentage ?? 5;
  const currentPercentage = operationsPercentageByCauseArea[causeArea.id] ?? defaultPercentage;
  const t10 = config?.operations_label_template;
  let t11;
  if ($[6] !== t10) {
    t11 = splitOperationsLabelTemplate(t10);
    $[6] = t10;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const {
    prefix: operationsLabelPrefix,
    suffix: operationsLabelSuffix
  } = t11;
  const isOperationsEnabled = operationsPercentageModeByCauseArea[causeArea.id] ?? false;
  const [inputValue, setInputValue] = React.useState(currentCauseAreaAmount);
  let t12;
  let t13;
  if ($[8] !== currentCauseAreaAmount) {
    t12 = () => {
      setInputValue(currentCauseAreaAmount);
    };
    t13 = [currentCauseAreaAmount];
    $[8] = currentCauseAreaAmount;
    $[9] = t12;
    $[10] = t13;
  } else {
    t12 = $[9];
    t13 = $[10];
  }
  React.useEffect(t12, t13);
  let t14;
  if ($[11] !== causeArea.id || $[12] !== dispatch) {
    t14 = checked => {
      dispatch(setOperationsPercentageModeByCauseArea(causeArea.id, checked));
    };
    $[11] = causeArea.id;
    $[12] = dispatch;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  const handleCutToggle = t14;
  let t15;
  if ($[14] !== causeArea.id || $[15] !== dispatch) {
    t15 = (values, sourceInfo) => {
      if (sourceInfo.source !== "event") {
        return;
      }
      const v = values.floatValue === undefined ? 0 : values.floatValue;
      const limitedPercentage = Math.min(Math.max(v, 0), 100);
      dispatch(setOperationsPercentageByCauseArea(causeArea.id, limitedPercentage));
    };
    $[14] = causeArea.id;
    $[15] = dispatch;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const handlePercentageChange = t15;
  const setTrackedOrganizationAmounts = amount => {
    if (!isTrackingPrefilledShares || !prefilledShares) {
      return;
    }
    causeArea.organizations.forEach(organization_2 => {
      const share = prefilledShares[organization_2.id];
      if (share !== undefined) {
        dispatch(setOrgAmount(organization_2.id, Math.round(share / 100 * amount)));
      }
    });
  };
  let t16;
  if ($[17] !== causeArea.id || $[18] !== causeArea.organizations[0] || $[19] !== dispatch || $[20] !== hasSingleOrg || $[21] !== setTrackedOrganizationAmounts) {
    t16 = (values_0, sourceInfo_0) => {
      if (sourceInfo_0.source !== "event") {
        return;
      }
      const v_0 = values_0.floatValue === undefined ? 0 : values_0.floatValue;
      setInputValue(v_0);
      dispatch(setCauseAreaAmount(causeArea.id, v_0));
      if (hasSingleOrg) {
        dispatch(setOrgAmount(causeArea.organizations[0].id, v_0));
      } else {
        setTrackedOrganizationAmounts(v_0);
      }
    };
    $[17] = causeArea.id;
    $[18] = causeArea.organizations[0];
    $[19] = dispatch;
    $[20] = hasSingleOrg;
    $[21] = setTrackedOrganizationAmounts;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  const handleAmountChange = t16;
  let t17;
  if ($[23] !== causeArea.id || $[24] !== causeArea.organizations[0] || $[25] !== dispatch || $[26] !== hasSingleOrg || $[27] !== plausible || $[28] !== setTrackedOrganizationAmounts) {
    t17 = amount_0 => {
      plausible("SelectSuggestedSum", {
        props: {
          sum: amount_0
        }
      });
      setInputValue(amount_0);
      dispatch(setCauseAreaAmount(causeArea.id, amount_0));
      if (hasSingleOrg) {
        dispatch(setOrgAmount(causeArea.organizations[0].id, amount_0));
      } else {
        setTrackedOrganizationAmounts(amount_0);
      }
    };
    $[23] = causeArea.id;
    $[24] = causeArea.organizations[0];
    $[25] = dispatch;
    $[26] = hasSingleOrg;
    $[27] = plausible;
    $[28] = setTrackedOrganizationAmounts;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const handleSuggestedSumClick = t17;
  const T0 = FormWrapper;
  const t18 = causeArea.id;
  let t19;
  if ($[30] !== causeArea.id) {
    t19 = getCauseAreaIconById(causeArea.id);
    $[30] = causeArea.id;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  const t20 = causeArea.widgetDisplayName || causeArea.name;
  let t21;
  if ($[32] !== t19 || $[33] !== t20) {
    t21 = <CauseAreaTitle>{t19}{t20}</CauseAreaTitle>;
    $[32] = t19;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== causeArea.id || $[36] !== causeAreaDisplayConfig) {
    t22 = getCauseAreaContext(causeArea.id, causeAreaDisplayConfig) && <CauseAreaContext>{getCauseAreaContext(causeArea.id, causeAreaDisplayConfig)}</CauseAreaContext>;
    $[35] = causeArea.id;
    $[36] = causeAreaDisplayConfig;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t21 || $[39] !== t22) {
    t23 = <div>{t21}{t22}</div>;
    $[38] = t21;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  const t24 = hideDistributionToggle ? <TotalSumWrapper>{isSingleSelection && <SumButtonsWrapper>{suggestedSums.map(suggested => <div key={suggested.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested.amount} onClick={() => handleSuggestedSumClick(suggested.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested.amount}`}>{`${suggested.amount ? thousandize(suggested.amount) : "-"} kr`}</EffektButton>{suggested.subtext && <i>{suggested.subtext}</i>}</div>)}</SumButtonsWrapper>}<SumWrapper><span><NumericFormat name={`sum-${causeArea.id}`} thousandSeparator=" " allowNegative={false} decimalScale={0} type="tel" placeholder="0" value={inputValue > 0 ? inputValue : ""} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></SumWrapper></TotalSumWrapper> : <><AnimateHeight height={causeAreaDistributionType[causeArea.id] === ShareType.STANDARD || causeAreaDistributionType[causeArea.id] === undefined ? "auto" : 0} animateOpacity={true} duration={300}><div style={{
        paddingBottom: "30px"
      }}><TotalSumWrapper>{isSingleSelection && <SumButtonsWrapper>{suggestedSums.map(suggested_0 => <div key={suggested_0.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested_0.amount} onClick={() => handleSuggestedSumClick(suggested_0.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested_0.amount}`}>{`${suggested_0.amount ? thousandize(suggested_0.amount) : "-"} kr`}</EffektButton>{suggested_0.subtext && <i>{suggested_0.subtext}</i>}</div>)}</SumButtonsWrapper>}<SumWrapper><span><NumericFormat name={`sum-${causeArea.id}`} type="tel" placeholder="0" thousandSeparator=" " value={inputValue > 0 ? inputValue : ""} allowNegative={false} step={1} decimalScale={0} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></SumWrapper></TotalSumWrapper></div></AnimateHeight><RadioButtonGroup options={[{
      title: smartDistributionContext.smart_distribution_radiobutton_text,
      value: ShareType.STANDARD,
      data_cy: `radio-smart-share-${causeArea.id}`
    }, {
      title: smartDistributionContext.custom_distribution_radiobutton_text,
      value: ShareType.CUSTOM,
      data_cy: `radio-custom-share-${causeArea.id}`,
      content: <InputList>{visibleOrganizations.map(org => <OrganizationInputWrapper key={org.id}><Link href={org.informationUrl || "#"} target={isMobile ? "_blank" : undefined} rel={isMobile ? "noopener noreferrer" : undefined}>{org.widgetDisplayName || org.name}</Link><span><NumericFormat id={`org-${org.id}`} aria-label={org.widgetDisplayName || org.name} type="tel" placeholder="0" value={orgAmounts[org.id] || ""} step={1} decimalScale={0} allowNegative={false} thousandSeparator=" " autoComplete="off" data-cy={`org-${org.id}`} onValueChange={(values_1, sourceInfo_1) => {
              if (sourceInfo_1.source !== "event") {
                return;
              }
              const v_1 = values_1.floatValue === undefined ? 0 : values_1.floatValue;
              if (prefilledShares?.[org.id] !== undefined) {
                dispatch(setHasManuallyEditedPrefilledOrgAmount(true));
              }
              dispatch(setOrgAmount(org.id, v_1));
            }} /></span></OrganizationInputWrapper>)}{hasPrefilledOrganizations && !showAllOrganizations && <EffektButton variant={EffektButtonVariant.SECONDARY} onClick={() => dispatch(setShowAllOrganizations(true))} data-cy="show-all-organizations-button">{smartDistributionContext.show_all_organizations_text} ↓</EffektButton>}</InputList>
    }]} selected={causeAreaDistributionType[causeArea.id] ?? ShareType.STANDARD} onSelect={val => {
      dispatch(setCauseAreaDistributionType(causeArea.id, val));
      if (val === ShareType.CUSTOM) {
        const hasSetOrgAmounts = Object.entries(orgAmounts).filter(t25 => {
          const [key, value] = t25;
          const orgId = parseInt(key);
          return value > 0 && causeArea.organizations.some(org_0 => org_0.id === orgId);
        }).length > 0;
        if (!hasSetOrgAmounts) {
          const causeAreaAmount = causeAreaAmounts[causeArea.id] || 0;
          for (const org_1 of causeArea.organizations) {
            if (!org_1.standardShare) {
              continue;
            }
            const orgShare = Math.round(org_1.standardShare / 100 * causeAreaAmount);
            dispatch(setOrgAmount(org_1.id, orgShare));
          }
        }
      }
    }} /></>;
  let t26;
  if ($[41] !== t24) {
    t26 = <div>{t24}</div>;
    $[41] = t24;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== causeArea.id || $[44] !== currentPercentage || $[45] !== handleCutToggle || $[46] !== handlePercentageChange || $[47] !== isOperationsEnabled || $[48] !== operationsLabelPrefix || $[49] !== operationsLabelSuffix || $[50] !== showOperationsOption) {
    t27 = showOperationsOption && <div><div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }}><CheckBoxWrapper><HiddenCheckBox type="checkbox" checked={isOperationsEnabled} onChange={e => handleCutToggle(e.target.checked)} data-cy={`cut-checkbox-${causeArea.id}`} /><CustomCheckBox checked={isOperationsEnabled} label="" /></CheckBoxWrapper><OperationsPercentageInputWrapper>{operationsLabelPrefix && <span>{operationsLabelPrefix}</span>}<span><NumericFormat name={`percentage-cut-${causeArea.id}`} allowNegative={false} decimalScale={1} max={100} type="tel" placeholder="5" value={currentPercentage} autoComplete="off" data-cy={`percentage-cut-input-${causeArea.id}`} onValueChange={handlePercentageChange} disabled={!isOperationsEnabled} /></span>{operationsLabelSuffix && <span>{operationsLabelSuffix}</span>}</OperationsPercentageInputWrapper></div></div>;
    $[43] = causeArea.id;
    $[44] = currentPercentage;
    $[45] = handleCutToggle;
    $[46] = handlePercentageChange;
    $[47] = isOperationsEnabled;
    $[48] = operationsLabelPrefix;
    $[49] = operationsLabelSuffix;
    $[50] = showOperationsOption;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== causeArea.id || $[53] !== causeAreaDisplayConfig) {
    t28 = <CauseAreaRollout causeAreaId={causeArea.id} config={causeAreaDisplayConfig} />;
    $[52] = causeArea.id;
    $[53] = causeAreaDisplayConfig;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== T0 || $[56] !== causeArea.id || $[57] !== t23 || $[58] !== t26 || $[59] !== t27 || $[60] !== t28) {
    t29 = <T0 key={t18}>{t23}{t26}{t27}{t28}</T0>;
    $[55] = T0;
    $[56] = causeArea.id;
    $[57] = t23;
    $[58] = t26;
    $[59] = t27;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  return t29;
};
const getCauseAreaContext = (id: number, config?: CauseAreaDisplayConfig) => {
  const context = config?.cause_area_contexts?.find(c => c.cause_area_id === id);
  return context?.context_text || null;
};
function _temp(state) {
  return state.donation;
}
function _temp2(organization) {
  return organization.isActive;
}
function _temp3(first, second) {
  return first.ordering - second.ordering;
}